import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faUserCircle,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";

import { Context } from "../backend/context";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

function Navbar(props) {
  const { isLoggedIn, user, signOut, name } = React.useContext(Context);

  return (
    <nav
      className="navbar fixed-top py-0 my-0 justify-content-between"
      style={{ backgroundColor: "black" }}
    >
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      <Link
        type="button"
        className="navbar-brand badge-dark left-0 px-3"
        to="/account"
        style={{ borderRadius: "50px" }}
      >
        Nash TradingBot
      </Link>
      <div className="row mr-2">
        <div className="col-4 m-auto align-self-center ">
          <Link className="nav-item notification" to="/account/notifications">
            <FontAwesomeIcon icon={faBell} size="1x" color="white" />
            {props.newNotifications > 0 && (
              <span className="badge">
                {props.newNotifications}
                {props.newNotifications > 98 && "+"}
              </span>
            )}
          </Link>
        </div>
        <div className="col-8" id="navbarNavDropdown">
          <div className="nav-item dropdown text-center">
            <div
              className="nav-link "
              id="categoryDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faUserCircle} size="2x" color="white" />
            </div>
            <div
              className="dropdown-menu dropdown-menu-right text-center border-dark border p-2"
              aria-labelledby="categoryDropdown"
              style={{
                backgroundColor: "#292b2c",
                borderStyle: "solid",
                borderColor: "white",
              }}
            >
              <span
                className="dropdown-item disabled"
                style={{ color: "white" }}
              >
                Signin as
              </span>
              <span
                className="dropdown-item disabled mb-1"
                style={{ color: "white" }}
              >
                {name}
              </span>
              <a
                className="dropdown-item nav-link btn btn-dark "
                target="_blank"
                href="https://t.me/joinchat/FK6BDEzuktU14lWpJ-wDnA"
                style={{ backgroundColor: "black", color: "white" }}
              >
                <span className="pr-2"> Support</span>
                <FontAwesomeIcon
                  icon={faExternalLinkAlt}
                  size="1x"
                  color="white"
                />
              </a>
              <Link
                className="dropdown-item nav-link btn btn-dark mt-2"
                to="/account/settings"
                style={{ backgroundColor: "black", color: "white" }}
              >
                Settings
              </Link>

              <hr
                style={{
                  border: "none",
                  height: "3px",
                  color: "black",
                  backgroundColor: "black",
                  margin: "5px",
                }}
              />
              <div className="text-center mb-1">
                <button
                  className="dropdown-item nav-link btn btn-dark"
                  style={{ backgroundColor: "#4d0000", color: "white" }}
                  onClick={signOut}
                >
                  LOGOUT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

const mapStateToProps = (state) => ({
  newNotifications: state.notifications.newNotifications,
});

export default connect(mapStateToProps)(Navbar);
